import React, { useState, useEffect } from 'react';
import api from '../api';
import { Eye } from 'lucide-react';
import ModeratorNavbar from './ModeratorNavbar';
import './ModeratorDashboard.css';

const ModeratorHiddenQueue = ({ onLogout }) => {
  const [hiddenPosts, setHiddenPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadHiddenPosts();
  }, []);

  const loadHiddenPosts = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await api.get('/api/moderator/hidden-posts');
      setHiddenPosts(response.data.reports || response.data || []);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load hidden posts');
    } finally {
      setLoading(false);
    }
  };

  const handleUnhidePost = async (postId) => {
    try {
      await api.post(`/api/moderator/post/${postId}/unhide`);
      alert('Post unhidden successfully');
      loadHiddenPosts();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to unhide post');
    }
  };

  return (
    <div className="moderator-shell">
      <ModeratorNavbar onLogout={onLogout} />

      {error && <div className="mod-alert">{error}</div>}

      <div className="moderator-content">
        <h2 className="section-title">Hidden Reports Queue</h2>
        
        {loading ? (
          <div className="loading">Loading hidden posts...</div>
        ) : (
          <div className="posts-list">
            {hiddenPosts.length === 0 ? (
              <div className="no-reports">No hidden reports found</div>
            ) : (
              hiddenPosts.map(report => (
                <div key={report.id} className="report-card hidden">
                  <div className="report-header">
                    <span className={`report-type ${report.type}`}>
                      {report.type ? report.type.replace(/_/g, ' ').replace('level', 'Level ') : 'Unknown'}
                    </span>
                    <span className="hidden-badge">HIDDEN</span>
                  </div>
                  
                  <div className="report-content">
                    <p><strong>Location:</strong> {report.address || report.location || 
                      (report.position ? `${report.position.lat.toFixed(4)}, ${report.position.lng.toFixed(4)}` : 'Not provided')}</p>
                    {report.description && <p>{report.description}</p>}
                    <p className="report-meta">
                      Hidden by: {report.hiddenByName || 'Unknown moderator'} on {new Date(report.hiddenAt || report.updatedAt || report.timestamp).toLocaleString()}
                    </p>
                    <p className="hide-reason"><strong>Reason:</strong> {report.hideReason || 'No reason provided'}</p>
                  </div>

                  <div className="report-actions">
                    <button 
                      className="btn btn-success btn-sm"
                      onClick={() => handleUnhidePost(report.id)}
                    >
                      <Eye size={14} /> Unhide Post
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModeratorHiddenQueue;
